import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Button, Input, Row } from "antd";
import AWS from "aws-sdk";
import moment from "moment";

import Swal from "sweetalert2";

import commentApi from "../../../apis/Comment.api";
import { toastAlert } from "../../AlertComponent";

import CommentFavorite from "./CommentFavorite";
import CommentImagePreviewGroup from "./CommentImagePreviewGroup";
import CommentImageSlideGroup from "./CommentImageSlideGroup";
import CommentImageUpload from "./CommentImageUpload";
import CommentReplyEach from "./CommentReplyEach";
import CommentReplyRegister from "./CommentReplyRegister";

AWS.config.update({
	accessKeyId: process.env.REACT_APP_S3_ACCESSKEYID,
	secretAccessKey: process.env.REACT_APP_S3_SECRETACCESSKEY,
	region: process.env.REACT_APP_S3_REGION,
});

const s3 = new AWS.S3();

const CommentEach = ({
	type,
	comment,
	index,
	getCommentList,
	getFindComment,
	comLoading,
	setComLoading,
	findComment,
	setFindComment,
	currentPageNumber,
}) => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);

	const [replyShow, setReplyShow] = useState(false);
	const [replyShowId, setReplyShowId] = useState(null);

	const [replyIdx, setReplyIdx] = useState(null);

	const [isCommentSet, setIsCommentSet] = useState(false);
	const [selectComment, setSelectComment] = useState({});

	const [imageList, setImageList] = useState([]);
	const [photoList, setPhotoList] = useState([]);
	const [biggestTitle, setBiggestTitle] = useState(0);

	// const [popoverOpen, setPopoverOpen] = useState(false);
	// const [popoverId, setPopoverId] = useState(null);
	// /**
	//  * popover click
	//  * @param id
	//  */
	// const handlePopover = (id) => {
	//     setPopoverId(id);
	//     setPopoverOpen(true);
	// }
	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	useEffect(() => {
		// console.log(isCommentSet);
		// setIsCommentSet(false);
		setSelectComment({});
		setIsCommentSet(false);
	}, [currentPageNumber]);

	useEffect(() => {
		// 댓글 이미지 리스트
		if (comment?.imageList?.length > 0) {
			// 타이틀 중 가장 큰 값 저장
			let bigTitle =
				comment?.imageList
					?.reduce((prev, value) => {
						return prev?.title?.split("-")?.[1] >= value?.title?.split("-")?.[1]
							? prev
							: value;
					})
					?.title?.split("-")?.[1] ?? 0;
			setBiggestTitle(bigTitle ? Number(bigTitle) : 0);

			let list = [];
			let photos = [];
			for (let i = 0; i < comment?.imageList?.length; i++) {
				let resultImageList = comment?.imageList[i];
				let source = `${process.env.REACT_APP_S3_HOST}/image/together/comment/${reduxChannel?.user_id}/${resultImageList?.title}.${resultImageList?.img_type}`;
				list.push(source);
				photos.push({
					title: resultImageList?.title,
					source: source,
					type: `image/${resultImageList?.img_type}`,
				});
			}
			// 최대 1개까지
			setImageList(list.slice(0, 1));
			setPhotoList(photos.slice(0, 1));
		} else {
			setImageList([]);
			setPhotoList([]);
		}
	}, [comment]);

	/**
	 * 이미지 삭제 (목록에서 제거 -> 작성/수정완료 클릭 시 적용)
	 * @param idx
	 */
	const onDeleteImage = (idx) => {
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 이미지를 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				let list = [...imageList];
				let photos = [...photoList];
				list.splice(idx, 1);
				photos.splice(idx, 1);
				setImageList(list);
				setPhotoList(photos);
			}
		});
	};

	/**
	 * 답글 보여주기
	 * @param index
	 */
	const handleShowCommentReply = (index) => {
		if (index === replyShowId) {
			setReplyShow(false);
			setReplyShowId(null);
		} else {
			setReplyShow(true);
			setReplyShowId(index);
		}
	};

	/**
	 * 답글쓰기 클릭 시 스크롤
	 */
	useEffect(() => {
		if (replyShow && replyShowId !== null) {
			const replyDiv = document.getElementById(`comment-reply-${replyShowId}`);

			const scrollFromTop = replyDiv?.getBoundingClientRect()?.top;
			const scrolledTopLength = window.scrollY;
			const fiftyVh = document.documentElement.clientHeight / 2;

			const scrollToTop = scrollFromTop + scrolledTopLength - fiftyVh;

			if (!type) {
				window.scrollTo({
					top: scrollToTop,
					behavior: "smooth",
				});
			} else {
				if (mediaResult) {
					window.scrollTo({
						top: scrollToTop,
						behavior: "smooth",
					});
				}
			}
		}
	}, [replyShow, replyShowId]);

	/**
	 * 댓글 수정
	 * @returns {Promise<void>}
	 */
	const onUpdateComment = async () => {
		if (selectComment?.content?.trim()?.length) {
			setComLoading(true);
			const param = {
				...selectComment,
				updated_by: cUser?.id,
				influencer_id: reduxChannel?.user_id,
			};
			const res = await commentApi.updateComment(param);
			if (res.code === 200) {
				updateImageList(param);
			} else {
				toastAlert("오류가 발생했습니다. 잠시 후에 다시 시도해주세요.");
			}
			setComLoading(false);
		} else {
			toastAlert("댓글을 작성해주세요.");
		}
	};

	/**
	 * 이미지 업로드
	 * @returns {Promise<void>}
	 * result: 결과값 -> id
	 * type: edit / save
	 */
	const updateImageList = async (result) => {
		let list = [];
		for (let i = 0; i < photoList?.length; i++) {
			let photo = photoList[i];

			// 등록
			if (photo?.file) {
				uploadToS3(result, photo, i);
				let fileType = photo?.type?.split("/")[1];
				list.push({
					title: `${result?.id}-${biggestTitle + i + 1}`,
					img_type: fileType,
				});
			}
			// 수정
			else {
				let fileType = photo?.type?.split("/")[1];
				list.push({
					title: photo?.title ?? `${result?.id}-${biggestTitle + i + 1}`,
					img_type: fileType,
				});
			}
		}

		const param = {
			target_id: result?.id,
			target_type: "comment",
			created_by: cUser?.id,
			imageList: [...list],
		};
		const res = await commentApi.postCommentImage(param);
		if (res.code === 200) {
			Swal.fire({
				customClass: "alert-custom",
				text: "정상적으로 수정이 완료되었습니다.",
				confirmButtonText: "확인",
			}).then(() => {
				getCommentList();
				setSelectComment({});
				setIsCommentSet(false);
				setImageList([]);
				setPhotoList([]);
				setFindComment(false);
			});
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "오류가 발생했습니다. 잠시 후에 다시 시도해주세요.",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("comment-image-list-error");
			});
		}
	};

	/**
	 * 이미지 S3 업로드
	 * @param result
	 * @param photo
	 * @param i
	 * @returns {Promise<void>}
	 */
	const uploadToS3 = async (result, photo, i) => {
		let fileType = photo?.type?.split("/")[1];
		let s3Path = `image/together/comment/${reduxChannel?.user_id}/${
			result?.id
		}-${biggestTitle + i + 1}.${fileType}`;
		//aws-sdk 사용
		let params = {
			Bucket: process.env.REACT_APP_S3_BUCKETNAME,
			Key: s3Path,
			Body: photo.file,
		};

		let res = await s3.putObject(params).promise();

		if (res.$response.httpResponse.statusCode === 200) {
			console.log("comment-s3-upload-success");
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "이미지 업로드 오류",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("comment-s3-upload-error");
				setComLoading(false);
			});
		}
	};

	/**
	 * 댓글 수정 취소
	 * @returns {Promise<void>}
	 */
	const onUpdateCancelComment = async () => {
		if (selectComment?.content !== comment?.content) {
			Swal.fire({
				customClass: "alert-custom",
				text: `수정 중인 내용이 있습니다.\n취소하시겠습니까?`,
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				if (result.isConfirmed) {
					setSelectComment({});
					setIsCommentSet(false);
				}
			});
		} else {
			setSelectComment({});
			setIsCommentSet(false);
		}
	};

	/**
	 * 댓글 삭제
	 * @returns {Promise<void>}
	 */
	const onDeleteComment = async () => {
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 댓글을 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				setComLoading(true);
				const param = {
					commentId: comment.id,
					userId: cUser?.id,
					influencer_id: reduxChannel?.user_id,
				};
				const res = await commentApi.deleteComment(param);
				if (res.code === 200) {
					Swal.fire({
						customClass: "alert-custom",
						text: "성공적으로 삭제되었습니다!",
						confirmButtonText: "확인",
					}).then(() => {
						getCommentList();
					});
				} else {
					toastAlert("오류가 발생했습니다. 잠시 후에 다시 시도해주세요.");
				}
				setComLoading(false);
			}
		});
	};

	return (
		<>
			<div className={`comment-user-div`}>
				<img
					src={`${
						comment?.is_influencer
							? `${process.env.REACT_APP_S3_HOST}/image/together/profile_${comment?.created_by}.${comment?.influencer_profile_img_type}`
							: comment?.is_app
							? comment?.profile_img_type && Number(comment?.profile_url) > 0
								? `${process.env.REACT_APP_S3_LONGLIFE_HOST}/images/profile/${comment.created_by}-${comment.profile_url}.${comment.profile_img_type}`
								: `/assets/images/channel/basic.png`
							: comment?.profile_img_type
							? `${process.env.REACT_APP_S3_HOST}/image/together/channel_user/profile/${comment?.created_by}.${comment?.profile_img_type}`
							: `/assets/images/channel/basic.png`
					}`}
					alt={`댓글 프로필 이미지`}
					onError={({ currentTarget }) => {
						currentTarget.onerror = null; // prevents looping
						// currentTarget.style.display = "none";
						currentTarget.src = `/assets/images/channel/basic.png`;
					}}
					className={`comment-img`}
				/>
				<Row align={"middle"}>
					{comment?.is_influencer ? (
						<p className={`user-phone influencer-id`}>
							{comment?.created_by_name}
						</p>
					) : (
						<p className={`user-phone`}>
							{comment?.created_by_name
								? comment?.created_by_name
								: comment?.phone}
						</p>
					)}
					<p className={`gray`}>ㆍ</p>
					<p className={`gray`}>
						{moment(moment(comment?.created_at), "YYYY.MM.DD").fromNow()}
					</p>
					{comment?.is_secret && (
						<>
							<p className={`gray`}>ㆍ</p>
							<img
								src={`/assets/images/channel/secret.png`}
								alt={`비밀댓글`}
								style={{
									height: "0.9em",
									width: "0.9em",
								}}
							/>
						</>
					)}
				</Row>

				<CommentFavorite item={comment} type={"comment"} />
			</div>
			{/* 댓글 수정 */}
			{!!isCommentSet && !!selectComment?.id ? (
				<div className={`update-comment-input`}>
					<Input.TextArea
						type={"text"}
						value={selectComment?.content}
						onChange={(e) => {
							setSelectComment({
								...selectComment,
								content: e.target.value,
							});
						}}
						disabled={comLoading}
					/>

					{/* 업로드한 이미지 보기 */}
					{!!imageList?.length && (
						<CommentImagePreviewGroup
							imageList={imageList}
							onDeleteImage={onDeleteImage}
							loading={comLoading}
						/>
					)}

					<Row
						className={`comment-input-button-group secret-button-group`}
						// style={commentShow ? {height: "auto", overflow: "hidden"} : {height: 0, overflow: "hidden"}}
					>
						{/* 댓글 이미지 업로드 */}
						<CommentImageUpload
							imageList={imageList}
							setImageList={setImageList}
							photoList={photoList}
							setPhotoList={setPhotoList}
						/>

						<div
							className={`is_secret`}
							onClick={() => {
								if (!comLoading) {
									setSelectComment({
										...selectComment,
										is_secret: !selectComment.is_secret,
									});
								}
							}}
							style={{
								marginRight: "auto",
								marginLeft: 0,
							}}
						>
							<img
								src={`/assets/images/login/check${
									selectComment.is_secret ? "-active" : ""
								}.png`}
								alt={`비밀글`}
								style={{
									height: "100%",
									width: "1em",
								}}
							/>
							비밀글
						</div>
						<Button
							size={`small`}
							className={`black`}
							onClick={onUpdateComment}
							disabled={comLoading}
						>
							수정
						</Button>
						<Button
							size={`small`}
							onClick={onUpdateCancelComment}
							disabled={comLoading}
						>
							취소
						</Button>
					</Row>
					<p
						style={{
							fontSize: "0.9em",
							color: "#6d7580",
							letterSpacing: "-0.5px",
						}}
					>
						* 이미지는 최대 1장까지 가능합니다.
					</p>
				</div>
			) : (
				<>
					{comment?.is_secret ? (
						<>
							{comment?.is_mine && comment?.content?.length ? (
								<>
									{!!comment?.imageList?.length && (
										<CommentImageSlideGroup
											imageList={comment?.imageList}
											type={"comment"}
										/>
									)}
									<p className={`comment-content`}>{comment?.content}</p>
								</>
							) : (
								<p className={`comment-content secret`}>비밀 댓글입니다</p>
							)}
						</>
					) : (
						<>
							{!!comment?.imageList?.length && (
								<CommentImageSlideGroup
									imageList={comment?.imageList}
									type={"comment"}
								/>
							)}
							<p className={`comment-content`}>{comment?.content}</p>
						</>
					)}
				</>
			)}
			{!isCommentSet && !selectComment?.id ? (
				<div className={`comment-footer`}>
					<p className={`comment-date`}>
						{moment(comment?.created_at).format("YYYY.MM.DD a hh:mm")}
					</p>
					<button
						className={`comment-reply`}
						onClick={() => handleShowCommentReply(index)}
						disabled={comLoading}
					>
						답글쓰기
					</button>

					{comment?.is_mine && (
						<>
							<button
								className={`comment-date`}
								onClick={() => {
									setSelectComment(comment);
									setIsCommentSet(true);
								}}
								disabled={comLoading}
							>
								수정
							</button>
							<button
								className={`comment-date`}
								onClick={onDeleteComment}
								disabled={comLoading}
							>
								삭제
							</button>
						</>
					)}
				</div>
			) : (
				<div className={`comment-footer`}></div>
			)}

			{!comment?.replyDTOList?.length ? (
				<>
					{replyShow && (
						<div className={`comment-reply-group`}>
							{/* 답글쓰기 */}
							<CommentReplyRegister
								comment={comment}
								index={index}
								replyShow={replyShow}
								replyShowId={replyShowId}
								getCommentList={getCommentList}
								getFindComment={getFindComment}
								comLoading={comLoading}
								setComLoading={setComLoading}
								findComment={findComment}
							/>
						</div>
					)}
				</>
			) : (
				<div className={`comment-reply-group`}>
					{comment?.replyDTOList?.map((reply, idx) => (
						<div className={`comment-reply-each`} key={`comment-reply-${idx}`}>
							<CommentReplyEach
								reply={reply}
								index={index}
								idx={idx}
								replyShow={replyShow}
								setReplyShow={setReplyShow}
								replyShowId={replyShowId}
								setReplyShowId={setReplyShowId}
								replyIdx={replyIdx}
								setReplyIdx={setReplyIdx}
								comLoading={comLoading}
								setComLoading={setComLoading}
								getCommentList={getCommentList}
								findComment={findComment}
								setFindComment={setFindComment}
								currentPageNumber={currentPageNumber}
							/>
						</div>
					))}

					{/* 답글쓰기 */}
					<CommentReplyRegister
						comment={comment}
						index={index}
						replyShow={replyShow}
						replyShowId={replyShowId}
						getCommentList={getCommentList}
						getFindComment={getFindComment}
						comLoading={comLoading}
						setComLoading={setComLoading}
						findComment={findComment}
					/>
				</div>
			)}
		</>
	);
};
export default CommentEach;
